/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Container, Col, Row } from 'reactstrap';
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Switch,
} from '@material-ui/core';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-day-picker/lib/style.css';
import { defineMessages, injectIntl } from 'react-intl';

import { change, Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import DatePickerField from './CoursePlanDate';
import CoursePlanTraining from './CoursePlanTraining';
import CoursePlanTypeOfLanguage from './CoursePlanTypeOfLanguage';
import CoursePlanHours from './CoursePlanHours';
import CoursePlanBook from './BookSelect/CoursePlanBook';
import CoursePlanObjectif from './Objectives/CoursePlanObjectif';
// import SessionCreation from './SessionCreation';

const messages = defineMessages({
  title: {
    id: 'CoursePlan.title',
    defaultMessage: 'Course',
  },
  from: {
    id: 'CoursePlan.from',
    defaultMessage: 'Date from',
  },
  to: {
    id: 'CoursePlan.to',
    defaultMessage: 'Date to',
  },
  titleRessource: {
    id: 'CoursePlan.titleRessource',
    defaultMessage: 'Gestion des ressources',
  },
  objectif: {
    id: 'CoursePlan.objectif',
    defaultMessage: 'Course objectives',
  },
  session: {
    id: 'CoursePlan.session',
    defaultMessage: 'Manage session',
  },
});

const styles = {
  root: {
    padding: 10,
    margin: 10,
  },
};

const renderSwitch = ({ input, label }) => (
  <div>
    <FormControlLabel
      control={(
        <Switch
          checked={!!input.value}
          onChange={input.onChange}
          color="primary"
        />
      )}
      label={label}
    />
  </div>
);

const renderSelectField = ({
  input, label, children, ...custom
}) => (
  <Select
    native
    {...input}
    {...custom}
    inputProps={{
      name: 'typeofexam',
      id: 'typeofexam-type',
    }}
    input={(
      <OutlinedInput
        name="typeofexam"
        labelWidth={100}
        id="outlined-typefirsttraining-simple"
      />
    )}
  >
    <option value="" />
    <option value="toeic">TOEIC</option>
    <option value="linguageneral">LinguaSkill General</option>
    <option value="linguabusiness">Linguaskill Business</option>
    <option value="bright">Bright</option>
    <option value="cloe">CLOE</option>
  </Select>
);

const CoursePlan = (props) => {
  const { intl } = props;
  const [loaded, setLoaded] = useState(false);
  const [beginDate, setbeginDate] = useState(new Date());
  const [endDate, setendDate] = useState(new Date());

  const initVal = async (keyName, defVal) => {
    const {
      dataform, form, dispatch, initialValues,
    } = props;

    if (dataform && dataform.values && dataform.values[keyName] !== undefined) {
      dispatch(change(`${form}`, `${keyName}`, dataform.values[keyName]));
      if (keyName === 'beginDate') setbeginDate(dataform.values[keyName]);
      else if (keyName === 'endDate') setendDate(dataform.values[keyName]);
    } else if (initialValues && initialValues[keyName] !== undefined) {
      dispatch(change(`${form}`, `${keyName}`, initialValues[keyName]));
      if (keyName === 'beginDate') setbeginDate(initialValues[keyName]);
      else if (keyName === 'endDate') setendDate(initialValues[keyName]);
    } else {
      dispatch(change(`${form}`, `${keyName}`, defVal));
      if (keyName === 'beginDate') setbeginDate(defVal);
      else if (keyName === 'endDate') setendDate(defVal);
    }
  };

  const setDefValue = async () => {
    await initVal('beginDate', new Date());
    await initVal('endDate', new Date());
    setLoaded(true);
  };
  useEffect(() => {
    setDefValue();
  }, []);

  if (!loaded) {
    return (<div />);
  }
  return (
    <div>
      <Container className="group-creation-container-centered">
        <Col className="courseplan-creation-card">
          <h3>{intl.formatMessage(messages.title)}</h3>
          <Row style={{ marginTop: '20px' }}>
            <Col md={4}>
              <FormControl
                variant="outlined"
                style={{ width: '100%' }}
              >
                <InputLabel htmlFor="outlined-typefirsttraining-simple">
                  Type of exam
                </InputLabel>
                <Field
                  name="typeofexam"
                  component={renderSelectField}
                  label="typeofexam-select"
                />
              </FormControl>
            </Col>
            <Col>
              <CoursePlanTraining />
            </Col>
            <Col>
              <CoursePlanTypeOfLanguage />
            </Col>
          </Row>
          <Row style={{ marginTop: '16px' }}>
            <Col md={4}>
              <CoursePlanHours />
            </Col>
            <Col md={3}>
              <FormControl
                variant="outlined"
                style={{ width: '100%' }}
              >

                <Field
                  name="beginDate"
                  label={intl.formatMessage(
                    messages.from,
                  )}
                  defaultValue={beginDate}
                  component={DatePickerField}
                />

              </FormControl>
            </Col>
            <Col md={3}>
              <FormControl
                variant="outlined"
                style={{ width: '100%' }}
              >
                <Field
                  name="endDate"
                  label={intl.formatMessage(
                    messages.to,
                  )}
                  defaultValue={endDate}
                  component={DatePickerField}
                />

              </FormControl>
            </Col>
          </Row>
          <Row style={{ marginTop: '16px' }}>
            <Col>
              <Row>
                <Col md={6}>

                  <Field
                    name="atCompany"
                    component={renderSwitch}
                    label="In company ?"
                  />

                </Col>
              </Row>
              <Row>
                <Col md={6}>

                  <Field
                    name="inPerson"
                    component={renderSwitch}
                    label="In Person ?"
                  />

                </Col>
              </Row>
              <Row>
                <Col md={6}>

                  <Field
                    name="middleTest"
                    component={renderSwitch}
                    label="Mid Course Test ?"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>

                  <Field
                    name="endTest"
                    component={renderSwitch}
                    label="End Course Test ?"
                  />

                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Container>
      {/* <Container className="group-creation-container-centered">
        <Col className="courseplan-creation-card">
          <h3>{intl.formatMessage(messages.session)}</h3>
          <Row style={{ marginTop: '20px' }}>
            <Col md={12}>
              <SessionCreation />
            </Col>
          </Row>
        </Col>
      </Container> */}
      <Container className="group-creation-container-centered">
        <Col className="courseplan-creation-card">
          <h3>{intl.formatMessage(messages.objectif)}</h3>
          <Row style={{ marginTop: '20px' }}>
            <Col md={12}>
              <CoursePlanObjectif />
            </Col>
          </Row>
        </Col>
      </Container>
      <Container className="group-creation-container-centered">
        <Col className="courseplan-creation-card">
          <h3>{intl.formatMessage(messages.titleRessource)}</h3>
          <Row style={{ marginTop: '20px' }}>
            <Col md={12}>
              <CoursePlanBook />
            </Col>
          </Row>
        </Col>
      </Container>
    </div>
  );
};

CoursePlan.propTypes = {
  intl: PropTypes.object.isRequired,
  form: PropTypes.any.isRequired,
  initialValues: PropTypes.any.isRequired,
  dataform: PropTypes.any.isRequired,
  dispatch: PropTypes.any.isRequired,
};

const CoursePlanTwo = withStyles(styles, { name: 'CoursePlan' })(CoursePlan);

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(CoursePlanTwo));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
